// extracted by mini-css-extract-plugin
export default {"quantity_container":"SK","hiddenflavorstring":"TK","loadingLine":"UK","productimgwrap":"VK","productimg":"WK","circlepic":"XK","productinfo":"YK","grey_x":"ZK","cartrow":"aL","bold":"bL","title":"cL","blue":"eL","strike":"fL","flexgap":"gL","flavorstring":"hL","nodecorate":"iL","flavorstring_link":"jL","rdstring":"kL","removeditemblock":"lL","removed_heading":"mL","removed_text":"nL","addback":"oL"};
    if(module.hot) {
      // 1713912566248
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  